import React from "react";
import { EmblaOptionsType } from "embla-carousel";
import useEmblaCarousel from "embla-carousel-react";
import {
  Embla,
  EmblaContainer,
  EmblaSlide,
  EmblaSlideText,
  EmblaViewport,
  H2Carousel,
  ImageCarousel,
  PCarousel,
} from "./styles";
import { legend } from "../../constants/legend_products";
import { useNavigate } from "react-router-dom";

type PropType = {
  slides: number[];
  options?: EmblaOptionsType;
};

const EmblaCarousel: React.FC<PropType> = (props) => {
  const { options } = props;
  const [emblaRef] = useEmblaCarousel(options);
  const navigate = useNavigate();

  const handleSlideClick = (item: any) => {
    navigate(`/products/${item.id}`);
  };

  return (
    <Embla>
      <EmblaViewport ref={emblaRef}>
        <EmblaContainer>
          {legend.slice(0, 5).map((item, index) => (
            <EmblaSlide key={index} onClick={() => handleSlideClick(item)}>
              <ImageCarousel src={item.imagem[0]} alt={`Slide ${index + 1}`} />
              <EmblaSlideText>
                <H2Carousel>
                  {item.descricao.replace("JERKED BEEF", "")}
                </H2Carousel>
                <PCarousel>{item.codigo}</PCarousel>
              </EmblaSlideText>
            </EmblaSlide>
          ))}

          <EmblaSlide
            onClick={() => navigate("/products")}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <EmblaSlideText style={{ textAlign: "center" }}>
              <H2Carousel style={{ fontSize: "5rem" }}>+</H2Carousel>
              <H2Carousel>{"Ver todos"}</H2Carousel>
            </EmblaSlideText>
          </EmblaSlide>
        </EmblaContainer>
      </EmblaViewport>
    </Embla>
  );
};

export default EmblaCarousel;
